import { render, staticRenderFns } from "./new-request.modal.vue?vue&type=template&id=2eb4a352&scoped=true"
import script from "./new-request.modal.vue?vue&type=script&lang=js"
export * from "./new-request.modal.vue?vue&type=script&lang=js"
import style0 from "./new-request.modal.vue?vue&type=style&index=0&id=2eb4a352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4a352",
  null
  
)

export default component.exports